<template>
    <div>
        <el-form ref="form"
                 :model="form"
                 label-width="120px"
                 @submit.prevent.native="onSubmit">
            <el-row :gutter="30">
                <el-col :span="19">
                    <div class="box">
                        <div class="box__header">
                            <span class="box__header--text">{{ getRouteName($route) }}</span>
                            <form-language-switcher></form-language-switcher>
                        </div>
                        <el-form-item label="Nazwa"
                                      :error="errors[addLanguageSuffix('name')]"
                                      required>
                            <el-input v-model="form[addLanguageSuffix('name')]">
                            </el-input>
                        </el-form-item>
                        <el-form-item label="Opis"
                                      :error="errors[addLanguageSuffix('description')]">
                            <wyswig-input v-model="form[addLanguageSuffix('description')]"/>
                        </el-form-item>
                        <edition-input v-model="form.edition"
                                       :errors="errors.edition"
                                       :required="true"/>
                        <el-form-item label="Popup">
                            <el-select v-model="form.popup"
                                       filterable
                                       clearable
                                       placeholder="Wybierz popup">
                                <el-option
                                        v-for="item in popups"
                                        :key="item.id"
                                        :label="item.working_name"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Logotyp"
                                      :error="errors['logotype']">
                            <image-input-component v-model="form.logotype"/>
                        </el-form-item>
                        <el-form-item label="Kategoria główna"
                                      :error="errors['category']">
                            <el-select filterable
                                       v-model="form.category"
                                       placeholder="Kategoria">
                                <el-option v-for="category in categories"
                                           :label="category.name_pl"
                                           :key="category.id"
                                           :value="category.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Podkategorie"
                                      :error="errors['tags']">
                            <el-select v-model="form['tags']"
                                       class="fluid"
                                       filterable
                                       multiple
                                       default-first-option
                                       placeholder="Tagi"
                                       allow-create>
                                <el-option
                                        v-for="item in availableTags"
                                        :key="item.name"
                                        :label="item.name"
                                        :value="item.name">
                                </el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="Miejsca"
                                      :error="errors['stages']">
                            <el-select filterable
                                       v-model="form.stages"
                                       multiple
                                       placeholder="Sceny">
                                <el-option v-for="stage in $store.state.stages"
                                           :label="stage.name_pl"
                                           :key="stage.id"
                                           :value="stage.id">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div>
                        <div class="box__header box__header--photos">
                            <span class="box__header--text">Zdjęcia:</span>
                        </div>
                        <photo-cropper :photo.sync="form.photo"
                                       :errors="errors"
                                       :croppers.sync="croppers"/>
                    </div>
                    <div>
                        <div class="box__header">
                            <span class="box__header--text">Widgety - widoczne w szczegółach:</span>
                        </div>
                        <widgets-input :widgets.sync="form.widgets"
                                       :errors="errors.widgets || []"/>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="box">
                        <div class="box__header">
                            {{ $t('manage') }}
                        </div>
                        <el-form-item class="form__buttons" label-width="0">
                            <router-link :to="redirectRoute">
                                <el-button class="fluid form__button">{{ $t('cancel') }}</el-button>
                            </router-link>
                            <el-button @click="onSubmit"
                                       type="primary"
                                       class="fluid form__button"
                                       :loading="loading">
                                {{ $t('submit') }}
                            </el-button>
                        </el-form-item>
                        <label>
                            Ukryj
                            <el-switch v-model="form.hide"/>
                        </label>
                    </div>
                </el-col>
            </el-row>
        </el-form>
    </div>
</template>
<script>
    import {Stand, StandCategory} from '@/api/';
    import PhotoCropper from '@/components/PhotoCropper'
    import WidgetsInput from '@/components/widgets/WidgetsInput'
    import {Popup} from '@/api'
    import EditionInput from '@/components/EditionInput'

    export default {
        data () {
            return {
                loading: false,
                redirectRoute: {name: 'Stands List'},
                form: {
                    widgets: []
                },
                errors: {},
                service: Stand,
                availableTags: [],
                popups: [],
                categories: []
            }
        },
        mounted () {
            this.fetchData()
        },
        components: {
            PhotoCropper,
            WidgetsInput,
            EditionInput
        },
        computed: {
            croppers: {
                set (updatedCroppers) {
                    updatedCroppers.forEach(cropper => {
                        this.$set(this.form, cropper.photoFieldName, cropper.img)
                        this.$set(this.form, cropper.paramsFieldName, cropper.params)
                    })
                },
                get () {
                    const croppers = [
                        {
                            id: 'square',
                            aspect: 1,
                            photoFieldName: 'square_photo',
                            paramsFieldName: 'square_crop_params',
                            label: 'Kadr kwadratowy'
                        },
                        {
                            id: 'horizontal',
                            aspect: 2,
                            photoFieldName: 'horizontal_photo',
                            paramsFieldName: 'horizontal_crop_params',
                            label: 'Kadr poziomy'
                        },
                        {
                            id: 'vertical',
                            aspect: 1 / 2,
                            photoFieldName: 'vertical_photo',
                            paramsFieldName: 'vertical_crop_params',
                            label: 'Kadr pionowy'
                        },
                    ]
                    const mergeFieldNameWithValues = cropper => {
                        return {
                            ...cropper,
                            img: this.form[cropper.photoFieldName],
                            params: this.form[cropper.paramsFieldName]
                        }
                    }
                    return croppers.map(mergeFieldNameWithValues)
                }
            }
        },
        methods: {
            fetchData () {
                this.fetchCategories()
                this.fetchPopups()
                this.$store.dispatch('fetchStages')
                this.$store.dispatch('fetchEditions')
                if (this.$route.params.id) {
                    this.service.get(this.$route.params.id).then(response => {
                        this.form = response.data
                        this.form.tags = this.form.tags.map(tag => tag.name)
                    })
                }
                this.service.tags().then(response => {
                    const listToObj = item => {
                        return {name: item.name, id: item.id}
                    }

                    this.availableTags = response.data.map(listToObj)
                })
            },
            fetchPopups () {
                Popup.all().then(response => {
                    this.popups = response.data
                })
            },
            fetchCategories () {
                StandCategory.fetch().then(response => {
                    this.categories = response.data
                })
            },
            onSubmit () {
                this.loading = true;
                const id = this.$route.params.id
                const payload = {...this.form}
                const prepareTags = tag => typeof tag === 'string' ? {name: tag} : tag
                payload.tags = payload.tags.map(prepareTags)
                const service = id ? this.service.update(id, payload) : this.service.save(payload)
                service
                    .then(this.successHandler)
                    .catch(this.errorHandler)
            }
        }
    }
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// StandForm.vue?0581a908